import React, { Component } from "react";
import { Container, Row } from "reactstrap";
import LoginPrompt from "./components/LoginPrompt";
import Navigation from "./components/Navigation";
import TrapList from "./components/TrapList";
import TrapSettings from "./components/TrapSettings";
import TrapData from "./components/TrapData";
import GeneralPane from "./components/GeneralPane";
import "bootstrap/dist/css/bootstrap.css";

var axios = require("axios");

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      settingsPane: false,
      dataPane: false,
      generalPane: false,
      selectedTrapId: null,
      logged: true,
      //restApi: "http://127.0.0.1:3000/rest",
      restApi: `http://${window.location.host.split(':')[0]}:5001/rest`,
      handle: "User",
      admin: false,
    };

    this.probeLoginStatus();

    this.probeLoginStatus = this.probeLoginStatus.bind(this);
    this.logoutAction = this.logoutAction.bind(this);
    this.selectTrap = this.selectTrap.bind(this);
    this.setSettingsPaneVisibility = this.setSettingsPaneVisibility.bind(this);
    this.setDataPaneVisibility = this.setDataPaneVisibility.bind(this);
    //this.setGeneralPaneVisibility = this.setGeneralPaneVisibility.bind(this);
  }

  probeLoginStatus() {
    axios({
      method: "get",
      url: this.state.restApi + "/users/probeLogin",
      withCredentials: true,
    })
      .then(
        function (response) {
          if (response.data.state === "logged_in")
            this.setState({
              logged: true,
              handle: response.data.handle,
              admin: response.data.admin,
            });
        }.bind(this)
      )
      .catch(function (error) {
        console.log(error);
      });
  }

  logoutAction() {
    axios({
      method: "get",
      url: this.state.restApi + "/users/logout",
      withCredentials: true,
    });
    this.setState({ logged: true });
  }

  selectTrap(id) {
    this.setState({ selectedTrapId: id });
  }

  setSettingsPaneVisibility(visible) {
    this.setState({ settingsPane: visible });
  }

  setDataPaneVisibility(visible) {
    if (visible) this.setState({ dataPane: visible });
    else {
      this.setState({
        dataPane: false,
        settingsPane: false,
        generalPane: false,
      });
    }
  }

  render() {
    const content = (
      <div>
        <Navigation
          restIp={this.state.restApi}
          handle={this.state.handle}
          admin={this.state.admin}
          logoutAction={this.logoutAction}
        />

        <Container fluid >
          <Row>
            <TrapList
              restIp={this.state.restApi}
              selectTrap={this.selectTrap}
            />
            {/* <TrapSettings
              restIp={this.state.restApi}
              visible={this.state.settingsPane}
              admin={this.state.admin}
              trapId={this.state.selectedTrapId}
              setSettingsPaneVisibility={this.setSettingsPaneVisibility}
            /> */}
            <TrapData
              restIp={this.state.restApi}
              visible={this.state.dataPane}
              trapId={this.state.selectedTrapId}
              setDataPaneVisibility={this.setDataPaneVisibility}
              settingsPane={this.state.settingsPane}
            />
            <GeneralPane
              restIp={this.state.restApi}
              visible={this.state.generalPane}
              selectTrap={this.selectTrap}
            />
          </Row>
        </Container>
      </div>
    );

    return (
      <div id="wrapper">
        {this.state.logged ? (
          content
        ) : (
          <LoginPrompt restIp={this.state.restApi} />
        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js